/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiTracksIdMutationRequest, PutApiTracksIdMutationResponse, PutApiTracksIdPathParams, PutApiTracksId400, PutApiTracksId401, PutApiTracksId403, PutApiTracksId404, PutApiTracksId500 } from "../../types/PutApiTracksId.ts";
import { putApiTracksIdMutationResponseSchema, putApiTracksIdMutationRequestSchema } from "../../zod/TracksSchemas/putApiTracksIdSchema.ts";

function getPutApiTracksIdUrl({ id }: { id: PutApiTracksIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/tracks/${id}` as const }  
  return res
}

/**
 * @summary Обновление трека по идентификатору
 * {@link /api/tracks/:Id}
 */
export async function putApiTracksId({ id, data }: { id: PutApiTracksIdPathParams["Id"]; data?: PutApiTracksIdMutationRequest }, config: Partial<RequestConfig<PutApiTracksIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiTracksIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiTracksIdMutationResponse, ResponseErrorConfig<PutApiTracksId400 | PutApiTracksId401 | PutApiTracksId403 | PutApiTracksId404 | PutApiTracksId500>, PutApiTracksIdMutationRequest>({ method : "PUT", url : getPutApiTracksIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiTracksIdMutationResponseSchema.parse(res.data)
}